/**
 * Detect fn
 */
export default () => 'freeze' in Object
